import React, { ReactElement } from 'react'
import { Center, Heading, VStack, Text } from '@chakra-ui/react'

const NoResultsView = (): ReactElement => {
  return (
    <Center w="100%">
      <VStack align="center" py={20} w="100%" spacing={4}>
        <Heading as="h1" size="4xl">
          🧐
        </Heading>
        <Text align="center" fontSize="2xl">
          <b> Nothing matching that search...</b>
        </Text>
      </VStack>
    </Center>
  )
}

export default NoResultsView
